// import 'babel-polyfill'
import Vue from 'vue'
import App from '@/App.vue'
import router from '@/router'
import store from '@/store'
import VueLazyload from 'vue-lazyload'
import VueResource from 'vue-resource'
import Inview from 'vueinview'
import DrawerLayout from 'vue-drawer-layout'
// import Raven from 'raven-js'
// import RavenVue from 'raven-js/plugins/vue'
// import config from './config'

// if(process.env.NODE_ENV === 'production'){
//   Raven
//     .config('https://ce38924897fb4af9924623ac8ff50e1c@sentry.io/1455818', {
//       release: config.SENTRY_RELEASE
//     })
//     .addPlugin(RavenVue, Vue)
//     .install();
// }else{
//   console.debug('Not configuring Sentry, environment is', process.env.NODE_ENV);
// }

Vue.config.productionTip = false
Vue.use(VueResource);
Vue.use(VueLazyload);
Vue.use(Inview);
Vue.use(DrawerLayout);

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
